import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { Permission } from '../interfaces/permission';
import { firstValueFrom } from 'rxjs';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const permission: Permission = route.data['permission'];

  try {
    // Get user
    const user = await firstValueFrom(authService.getUser());
    // If user is not authenticated, redirect to login page
    if (!user) {
      return router.createUrlTree(['/login']);
    }

    // Fetch permissions from the backend
    const permissions = await firstValueFrom(authService.getAllPermissions$());

    // Check if user has the required permission
    const hasPermission = permissions.includes(permission);
    if (!hasPermission) {
      // Check if this is right after a role switch
      const justSwitchedRole = localStorage.getItem('switchedRole') === 'true';

      if (justSwitchedRole) {
        // Clear the flag
        localStorage.removeItem('switchedRole');
        // Redirect to dashboard instead of 403 page
        return router.createUrlTree(['/']);
      } else {
        // Normal unauthorized access - show 403 page
        return router.createUrlTree(['/unauthorized']);
      }
    } else {
      // User has permission - clear the switchedRole flag if it exists
      localStorage.removeItem('switchedRole');
    }
  } catch (error) {
    // If there is an error, redirect to login page
    return router.createUrlTree(['/login']);
  }

  // If user is authenticated, return true
  return true;
};
